var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"mm-year-table"},[_c('tbody',{on:{"click":_vm.handleClick}},_vm._l((_vm.years),function(row,rowIndex){return _c('tr',{key:rowIndex},_vm._l((row),function(cell,cellIndex){return _c('td',{key:cellIndex,class:{
          'selected': cell === _vm.pickedYear,
          'disabled': _vm.isDisabled(rowIndex, cellIndex),
          'today': _vm.isToday(cell),
        }},[_c('span',{staticClass:"mm-year"},[_vm._v("\n          "+_vm._s(cell)+"\n        ")])])}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }